import React from "react";

import { StatusCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function status({ width, onResize }: Column.Options) {
	return base(ColumnId.Status, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default status;
